import { render, staticRenderFns } from "./order_notification_channel.vue?vue&type=template&id=c051f53c&scoped=true&"
import script from "./order_notification_channel.vue?vue&type=script&lang=js&"
export * from "./order_notification_channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c051f53c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c051f53c')) {
      api.createRecord('c051f53c', component.options)
    } else {
      api.reload('c051f53c', component.options)
    }
    module.hot.accept("./order_notification_channel.vue?vue&type=template&id=c051f53c&scoped=true&", function () {
      api.rerender('c051f53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/order_notification/order_notification_channel.vue"
export default component.exports